import { create } from 'zustand';
import { IDocument } from '../models/document.model';
import errorHandler from '../utils/error-handler.util';
import { IApiResponse } from '../models/resource.model';
import createAxiosInstance from '../services/global/axiosInstance';
import toast from 'react-hot-toast';

const axiosInstance = createAxiosInstance();

interface IDocumentStore {
  loading: boolean;
  uploadDocument: (document: IDocument) => Promise<IApiResponse>;
  getDocIdAfterUpload: (document: IDocument) => Promise<string>;
  removeDocument: (documentId: string) => Promise<IApiResponse>;
}

const useDocumentStore = create<IDocumentStore>((set, get) => ({
  loading: false,
  uploadDocument: async (document: IDocument) => {
    set({ loading: true });
    try {
      const response = await axiosInstance.post(
        '/documentutils/upload',
        document,
      );
      set({ loading: false });
      return response.data.value;
    } catch (err: any) {
      errorHandler(err);
      set({ loading: false });
    }
  },
  getDocIdAfterUpload: async (document: IDocument): Promise<string> => {
    const response = await get().uploadDocument(document);
    if (response && response.value.fileId) {
      toast.success('Document uploaded successfully.');
      return response.value.fileId;
    }
    toast.error('Error uploading document.');
    return '';
  },
  removeDocument: async (documentId: string) => {
    set({ loading: true });
    try {
      const response = await axiosInstance.delete(
        `/documentutils/remove-document/${documentId}`,
      );
      set({ loading: false });
      return response.data.value;
    } catch (err: any) {
      errorHandler(err);
      set({ loading: false });
    }
  },
}));

export default useDocumentStore;
